import { module } from 'modujs';
import { Validations, ValidationMessages } from '../utils/validations';

export default class extends module {

    constructor(m) {
        super(m);
        this.isValid = true;
        this.input = this.el.querySelector( 'input' );
        if( ! this.input ) this.input = this.el.querySelector( 'textarea' );
        this.label = this.el.querySelector( '[data-label]' );
        this.error = this.el.querySelector( '[data-error]' );
        this.passwordToggle = this.el.querySelector( '[data-password-toggle]' );;
        this.errorElements = [...this.el.querySelectorAll( '[data-error-class]' ) ];
        this.validations = this.el.dataset.validate ? this.el.dataset.validate.split( '|' ) : [];
        this.input.addEventListener( 'input', this.onInput.bind( this ) );
        this.input.addEventListener( 'focus', () => this.toggleLabel() );
        this.input.addEventListener( 'blur', () => {
            this.toggleLabel();
            this.validate();
        } );
        this.toggleLabel();

        if( this.passwordToggle ){
            this.passwordToggle.addEventListener( 'click', ( e ) => {
                e.preventDefault();
                this.input.setAttribute( 'type', this.input.getAttribute( 'type' ) === 'password' ? 'text' : 'password' );
                e.currentTarget.classList.toggle( 'is-text', this.input.getAttribute( 'type' ) === 'text' );
            } );
        }
    }

    toggleLabel(){
        if( this.input.type === 'checkbox' || ! this.label ) return;
        let op = this.input === document.activeElement  || this.input.value !== '' ? 'add' : 'remove';
        if( this.label.dataset.focusClass ){
            this.label.classList[ op ]( ...this.label.dataset.focusClass.split( ' ')  ) ;
        }
        return true;
    }

    validate(){
        this.isValid = true;
        for( let i = 0; i < this.validations.length; i++ ){
            let ruleParts = this.validations[i].split( ':' );
            let rule = ruleParts[0];
            let args = ruleParts[1] ? ruleParts[1] : false;
            if( Validations[ rule] ) {
                let isValid =  Validations[ rule ]( this.input, args );
                if( ! isValid  ){
                    if( this.isValid ){
                        this.error.textContent = ValidationMessages[ rule ].replace( '{x}', args );
                        this.isValid = false;
                    }
                }
                this.el.classList.toggle( 'invalid-' + rule, ! isValid );
                this.el.classList.toggle( 'valid-' + rule, isValid );
            }
        }
        if( this.isValid ) {
            this.errorElements.forEach( e => e.classList.remove( ...e.dataset.errorClass.split( ' ' ) ) );
        } else {
            this.errorElements.forEach( e => e.classList.add( ...e.dataset.errorClass.split( ' ' ) ) );
        }

        this.call( 'update', false, 'Scroll');

        return this.isValid;
    }

    onInput( ){
        if( this.input.type === 'checkbox' ){
            let toggleDisplay = this.el.dataset.toggleFieldDisplay;
            if( toggleDisplay ){
                [...this.el.closest( 'form' ).querySelectorAll( '[data-toggle-field-display-target="' +  toggleDisplay + '"]') ].forEach( e => e.classList.toggle( 'hidden', this.input.checked ) );
                this.call( 'update', false, 'Scroll');
                console.info('hi');
            }
        }
        if( ! this.isValid ) this.validate();
    }

}
